import { useCallback } from "react"
import { MakeTableHeadCell, MaybeSortedTableHeadCell, TableHeadCellGeneratorProps } from "../TableHeadCell"
import { TableColumnSortOrder } from "../types"

type Sort<SK> = {
  property: SK | undefined
  order: TableColumnSortOrder | undefined
}

export const useTableHeadCell = <T extends string, SK extends string>(
  sortData: (property: SK, newSort: TableColumnSortOrder | undefined) => void,
  feSortKeyValues: ReadonlyArray<SK>,
  hasData: boolean,
  sort?: Sort<SK>
) => {
  const SortedHeaderCell = useCallback(
    ({ header, property, tooltipContent }: TableHeadCellGeneratorProps<SK>) => (
      <MakeTableHeadCell<SK>
        header={header}
        sort={
          hasData
            ? {
                key: property,
                currentKey: sort?.property,
                currentOrder: sort?.order,
                fn: (order: TableColumnSortOrder | undefined) => {
                  sortData(property, order)
                },
              }
            : undefined
        }
        tooltipContent={tooltipContent}
      />
    ),
    [sort, sortData, hasData]
  )
  const HeaderCell = useCallback(
    ({ header, property, tooltipContent }: TableHeadCellGeneratorProps<T>) => (
      <MaybeSortedTableHeadCell<T, SK>
        header={header}
        property={property}
        tooltipContent={tooltipContent}
        feSortKeys={feSortKeyValues}
        SortedHeaderCell={SortedHeaderCell}
      />
    ),
    [SortedHeaderCell, feSortKeyValues]
  )
  return {
    HeaderCell,
  }
}
